import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem } from "@mui/material";
import {
  bindMenu,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MuiIconButton } from "../../../../../components";
import PermissionWrapper from "../../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../../helpers/constants";
import { COMPONENT_IDS } from "../../../../../helpers/constants/componentIds";
import { useNavigationSiteCore } from "../../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { createClientSelector } from "../../../../../redux/slices/client/createClientSelector";
import { ClientContact } from "../../../modelsAndSchemas/Models";
import { OptionMenuWrapper } from "./OptionMenu.style";

export interface OptionMenuProps {
  clientData: ClientContact;
  onClickOptionEdit: (row: ClientContact) => void;
  onClickOptionDelete: (row: ClientContact) => void;
}

export const OptionMenu: React.FC<OptionMenuProps> = ({
  clientData,
  onClickOptionEdit,
  onClickOptionDelete,
}) => {
  const { id: clientId } = useSelector(createClientSelector);
  const [showDeleteMenu, setShowDeleteMenu] = useState(false);
  const { commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();
  const popupState = usePopupState({
    popupId: `${clientData.clientContactId}`,
    variant: "popover",
  });

  useEffect(() => {
    const shouldShowDeleteMenu =
      clientData.isAttachedToCurrentClient &&
      (clientData.usedByClients.length === 0 ||
        (clientData.usedByClients.length === 1 &&
          clientData.usedByClients[0].clientId === clientId));

    setShowDeleteMenu(shouldShowDeleteMenu);
  }, [clientData, clientId]);

  return (
    <OptionMenuWrapper>
      <MuiIconButton
        className="option-menu-icon"
        {...bindTrigger(popupState)}
        data-testid={`${COMPONENT_IDS.COMMON_OPTION_MENU}-${clientData.clientContactId}`}
        aria-label={commonARIALabel.moreOptionsForThisTableRow}
      >
        <MoreVertIcon />
      </MuiIconButton>

      <Menu {...bindMenu(popupState)}>
        <PermissionWrapper permission={MODULE_PERMISSIONS.EDIT_CLIENT_CONTACTS}>
          <MenuItem
            data-testid={`${COMPONENT_IDS.COMMON_OPTION_MENU_EDIT}-${clientData.clientContactId}`}
            onClick={() => {
              popupState.close();
              onClickOptionEdit(clientData);
            }}
          >
            {commonLabels.edit}
          </MenuItem>
        </PermissionWrapper>
        <PermissionWrapper
          permission={
            clientData.isAttachedToCurrentClient
              ? MODULE_PERMISSIONS.DELETE_CLIENT_CONTACTS
              : MODULE_PERMISSIONS.DELETE_CLIENT_PARENT_CONTACTS
          }
        >
          {showDeleteMenu && (
            <MenuItem
              data-testid={`${COMPONENT_IDS.COMMON_OPTION_MENU_DELETE}-${clientData.clientContactId}`}
              onClick={() => {
                popupState.close();
                onClickOptionDelete(clientData);
              }}
            >
              {commonLabels.delete}
            </MenuItem>
          )}
        </PermissionWrapper>
      </Menu>
    </OptionMenuWrapper>
  );
};
